export const Currencies = [
  {
    currency_name: "Afghan Afghani",
    currency_symbol: "AFN",
    currency_iso_code: "AFN",
    country: "Afghanistan",
    country_iso_code: "AF",
  },
  {
    currency_name: "Albanian Lek",
    currency_symbol: "Lek",
    currency_iso_code: "ALL",
    country: "Albania",
    country_iso_code: "AL",
  },
  {
    currency_name: "Algerian Dinar",
    currency_symbol: "DZD",
    currency_iso_code: "DZD",
    country: "Algeria",
    country_iso_code: "DZ",
  },
  {
    currency_name: "Angolan Kwanza",
    currency_symbol: "Kz",
    currency_iso_code: "AOA",
    country: "Angola",
    country_iso_code: "AO",
  },
  {
    currency_name: "Argentine Peso",
    currency_symbol: "$",
    currency_iso_code: "ARS",
    country: "Argentina",
    country_iso_code: "AR",
  },
  {
    currency_name: "Armenian Dram",
    currency_symbol: "֏",
    currency_iso_code: "AMD",
    country: "Armenia",
    country_iso_code: "AM",
  },
  {
    currency_name: "Aruban Guilder",
    currency_symbol: "ƒ",
    currency_iso_code: "AWG",
    country: "Aruba",
    country_iso_code: "AW",
  },
  {
    currency_name: "Australian Dollar",
    currency_symbol: "$",
    currency_iso_code: "AUD",
    country: "Australia",
    country_iso_code: "AU",
  },
  {
    currency_name: "Azerbaijanian Manat",
    currency_symbol: "₼",
    currency_iso_code: "AZN",
    country: "Azerbaijan",
    country_iso_code: "AZ",
  },
  {
    currency_name: "Bahamian Dollar",
    currency_symbol: "$",
    currency_iso_code: "BSD",
    country: "Bahamas",
    country_iso_code: "BS",
  },
  {
    currency_name: "Bahraini Dinar",
    currency_symbol: "BHD",
    currency_iso_code: "BHD",
    country: "Bahrain",
    country_iso_code: "BH",
  },
  {
    currency_name: "Bangladeshi Taka",
    currency_symbol: "৳",
    currency_iso_code: "BDT",
    country: "Bangladesh",
    country_iso_code: "BD",
  },
  {
    currency_name: "Barbadian Dollar",
    currency_symbol: "$",
    currency_iso_code: "BBD",
    country: "Barbados",
    country_iso_code: "BB",
  },
  {
    currency_name: "Belarussian Ruble",
    currency_symbol: "BYN",
    currency_iso_code: "BYN",
    country: "Belarus",
    country_iso_code: "BY",
  },
  {
    currency_name: "Belize Dollar",
    currency_symbol: "BZ$",
    currency_iso_code: "BZD",
    country: "Belize",
    country_iso_code: "BZ",
  },
  {
    currency_name: "CFA Franc BCEAO",
    currency_symbol: "CFA",
    currency_iso_code: "XOF",
    country: "Benin",
    country_iso_code: "BJ",
  },
  {
    currency_name: "Bermudian Dollar (Bermuda Dollar)",
    currency_symbol: "$",
    currency_iso_code: "BMD",
    country: "Bermuda",
    country_iso_code: "BM",
  },
  {
    currency_name: "Bhutanese Ngultrum",
    currency_symbol: "BTN",
    currency_iso_code: "BTN",
    country: "Bhutan",
    country_iso_code: "BT",
  },
  {
    currency_name: "Bolivian Boliviano",
    currency_symbol: "$b",
    currency_iso_code: "BOB",
    country: "Bolivia, Plurinational State of",
    country_iso_code: "BO",
  },
  {
    currency_name: "Mvdol",
    currency_symbol: "Mvdol",
    currency_iso_code: "BOV",
    country: "Bolivia, Plurinational State of",
    country_iso_code: "BO",
  },
  {
    currency_name: "Bosnia and Herzegovina Convertible Marks",
    currency_symbol: "KM",
    currency_iso_code: "BAM",
    country: "Bosnia and Herzegovina",
    country_iso_code: "BA",
  },
  {
    currency_name: "Botswana Pula",
    currency_symbol: "P",
    currency_iso_code: "BWP",
    country: "Botswana",
    country_iso_code: "BW",
  },
  {
    currency_name: "Brazilian Real",
    currency_symbol: "R$",
    currency_iso_code: "BRL",
    country: "Brazil",
    country_iso_code: "BR",
  },
  {
    currency_name: "Brunei Dollar",
    currency_symbol: "$",
    currency_iso_code: "BND",
    country: "Brunei Darussalam",
    country_iso_code: "BN",
  },
  {
    currency_name: "Bulgarian Lev",
    currency_symbol: "лв",
    currency_iso_code: "BGN",
    country: "Bulgaria",
    country_iso_code: "BG",
  },
  {
    currency_name: "Burundian Franc",
    currency_symbol: "FBu",
    currency_iso_code: "BIF",
    country: "Burundi",
    country_iso_code: "BI",
  },
  {
    currency_name: "Cambodian Riel",
    currency_symbol: "៛",
    currency_iso_code: "KHR",
    country: "Cambodia",
    country_iso_code: "KH",
  },
  {
    currency_name: "Canadian Dollar",
    currency_symbol: "$",
    currency_iso_code: "CAD",
    country: "Canada",
    country_iso_code: "CA",
  },
  {
    currency_name: "Cape Verdean Escudo",
    currency_symbol: "CVE",
    currency_iso_code: "CVE",
    country: "Cape Verde",
    country_iso_code: "CV",
  },
  {
    currency_name: "Cayman Islands Dollar",
    currency_symbol: "$",
    currency_iso_code: "KYD",
    country: "Cayman Islands",
    country_iso_code: "KY",
  },
  {
    currency_name: "Central African CFA Franc",
    currency_symbol: "FCFA",
    currency_iso_code: "XAF",
    country: "Central African Republic",
    country_iso_code: "CF",
  },
  {
    currency_name: "Chilean Unidades de formento",
    currency_symbol: "CLF",
    currency_iso_code: "CLF",
    country: "Chile",
    country_iso_code: "CL",
  },
  {
    currency_name: "Chilean Peso",
    currency_symbol: "$",
    currency_iso_code: "CLP",
    country: "Chile",
    country_iso_code: "CL",
  },
  {
    currency_name: "Yuan Renminbi",
    currency_symbol: "CNY",
    currency_iso_code: "CNY",
    country: "China",
    country_iso_code: "CN",
  },
  {
    currency_name: "Colombian Peso",
    currency_symbol: "$",
    currency_iso_code: "COP",
    country: "Colombia",
    country_iso_code: "CO",
  },
  {
    currency_name: "Unidad de Valor Real",
    currency_symbol: "COU",
    currency_iso_code: "COU",
    country: "Colombia",
    country_iso_code: "CO",
  },
  {
    currency_name: "Comorian Franc",
    currency_symbol: "CF",
    currency_iso_code: "KMF",
    country: "Comoros",
    country_iso_code: "KM",
  },
  {
    currency_name: "Costa Rican Colon",
    currency_symbol: "¢",
    currency_iso_code: "CRC",
    country: "Costa Rica",
    country_iso_code: "CR",
  },
  {
    currency_name: "Croatian Kuna",
    currency_symbol: "kn",
    currency_iso_code: "HRK",
    country: "Croatia",
    country_iso_code: "HR",
  },
  {
    currency_name: "Cuban Convertible Peso",
    currency_symbol: "CUC$",
    currency_iso_code: "CUC",
    country: "Cuba",
    country_iso_code: "CU",
  },
  {
    currency_name: "Cuban Peso",
    currency_symbol: "₱",
    currency_iso_code: "CUP",
    country: "Cuba",
    country_iso_code: "CU",
  },
  {
    currency_name: "Czech Koruna",
    currency_symbol: "Kc",
    currency_iso_code: "CZK",
    country: "Czech Republic",
    country_iso_code: "CZ",
  },
  {
    currency_name: "Congolese franc",
    currency_symbol: "CDF",
    currency_iso_code: "CDF",
    country: "Congo, The Democratic Republic of the Congo",
    country_iso_code: "CD",
  },
  {
    currency_name: "Danish Krone",
    currency_symbol: "kr",
    currency_iso_code: "DKK",
    country: "Denmark",
    country_iso_code: "DK",
  },
  {
    currency_name: "Djiboutian Franc",
    currency_symbol: "DJF",
    currency_iso_code: "DJF",
    country: "Djibouti",
    country_iso_code: "DJ",
  },
  {
    currency_name: "Dominican Peso",
    currency_symbol: "$",
    currency_iso_code: "DOP",
    country: "Dominican Republic",
    country_iso_code: "DO",
  },
  {
    currency_name: "Eastern Caribbean Dollar",
    currency_symbol: "EC$",
    currency_iso_code: "XCD",
    country: "East Caribbean",
    country_iso_code: "#N/A",
  },
  {
    currency_name: "Egyptian Pound",
    currency_symbol: "£",
    currency_iso_code: "EGP",
    country: "Egypt",
    country_iso_code: "EG",
  },
  {
    currency_name: "El Salvador Colon",
    currency_symbol: "¢",
    currency_iso_code: "SVC",
    country: "El Salvador",
    country_iso_code: "SV",
  },
  {
    currency_name: "Eritrean Nakfa",
    currency_symbol: "ERN",
    currency_iso_code: "ERN",
    country: "Eritrea",
    country_iso_code: "ER",
  },
  {
    currency_name: "Ethiopian Birr",
    currency_symbol: "ETB",
    currency_iso_code: "ETB",
    country: "Ethiopia",
    country_iso_code: "ET",
  },
  {
    currency_name: "Euro",
    currency_symbol: "€",
    currency_iso_code: "EUR",
    country: "European Union",
    country_iso_code: "EU",
  },
  {
    currency_name: "Falkland Islands Pound",
    currency_symbol: "£",
    currency_iso_code: "FKP",
    country: "Falkland Islands (Malvinas)",
    country_iso_code: "FK",
  },
  {
    currency_name: "Fijian Dollar",
    currency_symbol: "$",
    currency_iso_code: "FJD",
    country: "Fiji",
    country_iso_code: "FJ",
  },
  {
    currency_name: "CFP Franc",
    currency_symbol: "₣",
    currency_iso_code: "XPF",
    country: "French Polynesia",
    country_iso_code: "PF",
  },
  {
    currency_name: "Gambian Dalasi",
    currency_symbol: "GMD",
    currency_iso_code: "GMD",
    country: "Gambia",
    country_iso_code: "GM",
  },
  {
    currency_name: "Georgian Lari",
    currency_symbol: "GEL",
    currency_iso_code: "GEL",
    country: "Georgia",
    country_iso_code: "GE",
  },
  {
    currency_name: "Ghanaian Cedi",
    currency_symbol: "¢",
    currency_iso_code: "GHS",
    country: "Ghana",
    country_iso_code: "GH",
  },
  {
    currency_name: "Gibraltar Pound",
    currency_symbol: "£",
    currency_iso_code: "GIP",
    country: "Gibraltar",
    country_iso_code: "GI",
  },
  {
    currency_name: "Guatemalan Quetzal",
    currency_symbol: "Q",
    currency_iso_code: "GTQ",
    country: "Guatemala",
    country_iso_code: "GT",
  },
  {
    currency_name: "Guernsey Pound",
    currency_symbol: "£",
    currency_iso_code: "GGP",
    country: "Guernsey",
    country_iso_code: "GG",
  },
  {
    currency_name: "Guinean Franc",
    currency_symbol: "GNF",
    currency_iso_code: "GNF",
    country: "Guinea",
    country_iso_code: "GN",
  },
  {
    currency_name: "Guyanese Dollar",
    currency_symbol: "$",
    currency_iso_code: "GYD",
    country: "Guyana",
    country_iso_code: "GY",
  },
  {
    currency_name: "Haitian Gourde",
    currency_symbol: "HTG",
    currency_iso_code: "HTG",
    country: "Haiti",
    country_iso_code: "HT",
  },
  {
    currency_name: "Honduran Lempira",
    currency_symbol: "L",
    currency_iso_code: "HNL",
    country: "Honduras",
    country_iso_code: "HN",
  },
  {
    currency_name: "Hong Kong Dollar",
    currency_symbol: "HK$",
    currency_iso_code: "HKD",
    country: "Hong Kong",
    country_iso_code: "HK",
  },
  {
    currency_name: "Hungarian Forint",
    currency_symbol: "Ft",
    currency_iso_code: "HUF",
    country: "Hungary",
    country_iso_code: "HU",
  },
  {
    currency_name: "Icelandic Krona",
    currency_symbol: "kr",
    currency_iso_code: "ISK",
    country: "Iceland",
    country_iso_code: "IS",
  },
  {
    currency_name: "Indian Rupee",
    currency_symbol: "₹",
    currency_iso_code: "INR",
    country: "India",
    country_iso_code: "IN",
  },
  {
    currency_name: "Indonesian Rupiah",
    currency_symbol: "Rp",
    currency_iso_code: "IDR",
    country: "Indonesia",
    country_iso_code: "ID",
  },
  {
    currency_name: "Iranian Rial",
    currency_symbol: "IRR",
    currency_iso_code: "IRR",
    country: "Iran, Islamic Republic of Persian Gulf",
    country_iso_code: "IR",
  },
  {
    currency_name: "Iraqi Dinar",
    currency_symbol: "IQD",
    currency_iso_code: "IQD",
    country: "Iraq",
    country_iso_code: "IQ",
  },
  {
    currency_name: "Manx Pound",
    currency_symbol: "£",
    currency_iso_code: "IMP",
    country: "Isle of Man",
    country_iso_code: "IM",
  },
  {
    currency_name: "Israeli new shekel",
    currency_symbol: "₪",
    currency_iso_code: "ILS",
    country: "Israel",
    country_iso_code: "IL",
  },
  {
    currency_name: "Jamaican Dollar",
    currency_symbol: "$",
    currency_iso_code: "JMD",
    country: "Jamaica",
    country_iso_code: "JM",
  },
  {
    currency_name: "Japanese Yen",
    currency_symbol: "¥",
    currency_iso_code: "JPY",
    country: "Japan",
    country_iso_code: "JP",
  },
  {
    currency_name: "Jersey Pound",
    currency_symbol: "£",
    currency_iso_code: "JEP",
    country: "Jersey",
    country_iso_code: "JE",
  },
  {
    currency_name: "Jordanian Dinar",
    currency_symbol: "JOD",
    currency_iso_code: "JOD",
    country: "Jordan",
    country_iso_code: "JO",
  },
  {
    currency_name: "Kazakhstani Tenge",
    currency_symbol: "₸",
    currency_iso_code: "KZT",
    country: "Kazakhstan",
    country_iso_code: "KZ",
  },
  {
    currency_name: "Kenyan Shilling",
    currency_symbol: "KES",
    currency_iso_code: "KES",
    country: "Kenya",
    country_iso_code: "KE",
  },
  {
    currency_name: "Kuwaiti Dinar",
    currency_symbol: "KWD",
    currency_iso_code: "KWD",
    country: "Kuwait",
    country_iso_code: "KW",
  },
  {
    currency_name: "Kyrgyzstani Som",
    currency_symbol: "лв",
    currency_iso_code: "KGS",
    country: "Kyrgyzstan",
    country_iso_code: "KG",
  },
  {
    currency_name: "Lao Kip",
    currency_symbol: "₭",
    currency_iso_code: "LAK",
    country: "Laos",
    country_iso_code: "LA",
  },
  {
    currency_name: "Lebanese Pound",
    currency_symbol: "£",
    currency_iso_code: "LBP",
    country: "Lebanon",
    country_iso_code: "LB",
  },
  {
    currency_name: "Lesotho Loti",
    currency_symbol: "LSL",
    currency_iso_code: "LSL",
    country: "Lesotho",
    country_iso_code: "LS",
  },
  {
    currency_name: "Liberian Dollar",
    currency_symbol: "L$",
    currency_iso_code: "LRD",
    country: "Liberia",
    country_iso_code: "LR",
  },
  {
    currency_name: "Libyan Dinar",
    currency_symbol: "LYD",
    currency_iso_code: "LYD",
    country: "Libyan Arab Jamahiriya",
    country_iso_code: "LY",
  },
  {
    currency_name: "Macanese Pataca",
    currency_symbol: "MOP",
    currency_iso_code: "MOP",
    country: "Macao",
    country_iso_code: "MO",
  },
  {
    currency_name: "Macedonian Denar",
    currency_symbol: "ден",
    currency_iso_code: "MKD",
    country: "Macedonia",
    country_iso_code: "MK",
  },
  {
    currency_name: "Malagascy Ariary",
    currency_symbol: "Ar",
    currency_iso_code: "MGA",
    country: "Madagascar",
    country_iso_code: "MG",
  },
  {
    currency_name: "Malawian Kwacha",
    currency_symbol: "MK",
    currency_iso_code: "MWK",
    country: "Malawi",
    country_iso_code: "MW",
  },
  {
    currency_name: "Malaysian Ringgit",
    currency_symbol: "RM",
    currency_iso_code: "MYR",
    country: "Malaysia",
    country_iso_code: "MY",
  },
  {
    currency_name: "Maldivian Rufiyaa",
    currency_symbol: "MVR",
    currency_iso_code: "MVR",
    country: "Maldives",
    country_iso_code: "MV",
  },
  {
    currency_name: "Ouguiya",
    currency_symbol: "UM",
    currency_iso_code: "MRO",
    country: "Mauritania",
    country_iso_code: "MR",
  },
  {
    currency_name: "Ouguiya",
    currency_symbol: "UM",
    currency_iso_code: "MRU",
    country: "Mauritania",
    country_iso_code: "MR",
  },
  {
    currency_name: "Mauritian Rupee",
    currency_symbol: "Rs",
    currency_iso_code: "MUR",
    country: "Mauritius",
    country_iso_code: "MU",
  },
  {
    currency_name: "Mexican Peso",
    currency_symbol: "$",
    currency_iso_code: "MXN",
    country: "Mexico",
    country_iso_code: "MX",
  },
  {
    currency_name: "Mexican Unidad de Inversion (UID)",
    currency_symbol: "MXV",
    currency_iso_code: "MXV",
    country: "Mexico",
    country_iso_code: "MX",
  },
  {
    currency_name: "Moldovan Leu",
    currency_symbol: "MDL",
    currency_iso_code: "MDL",
    country: "Moldova",
    country_iso_code: "MD",
  },
  {
    currency_name: "Mongolian Tugrik",
    currency_symbol: "₮",
    currency_iso_code: "MNT",
    country: "Mongolia",
    country_iso_code: "MN",
  },
  {
    currency_name: "Moroccan Dirham",
    currency_symbol: "MAD",
    currency_iso_code: "MAD",
    country: "Morocco",
    country_iso_code: "MA",
  },
  {
    currency_name: "Mozambican Metical",
    currency_symbol: "MT",
    currency_iso_code: "MZN",
    country: "Mozambique",
    country_iso_code: "MZ",
  },
  {
    currency_name: "Burmese Kyat",
    currency_symbol: "K",
    currency_iso_code: "MMK",
    country: "Myanmar",
    country_iso_code: "MM",
  },
  {
    currency_name: "Namibian Dollar",
    currency_symbol: "$",
    currency_iso_code: "NAD",
    country: "Namibia",
    country_iso_code: "NA",
  },
  {
    currency_name: "Nepalese Rupee",
    currency_symbol: "रु",
    currency_iso_code: "NPR",
    country: "Nepal",
    country_iso_code: "NP",
  },
  {
    currency_name: "Netherlands Antillian Guilder",
    currency_symbol: "ƒ",
    currency_iso_code: "ANG",
    country: "Netherlands Antilles",
    country_iso_code: "AN",
  },
  {
    currency_name: "New Zealand Dollar",
    currency_symbol: "$",
    currency_iso_code: "NZD",
    country: "New Zealand",
    country_iso_code: "NZ",
  },
  {
    currency_name: "Nicaraguan Cordoba Oro",
    currency_symbol: "C$",
    currency_iso_code: "NIO",
    country: "Nicaragua",
    country_iso_code: "NI",
  },
  {
    currency_name: "Nigerian Naira",
    currency_symbol: "₦",
    currency_iso_code: "NGN",
    country: "Nigeria",
    country_iso_code: "NG",
  },
  {
    currency_name: "North Korean Won",
    currency_symbol: "₩",
    currency_iso_code: "KPW",
    country: "Korea, Democratic People's Republic of Korea",
    country_iso_code: "KP",
  },
  {
    currency_name: "Norwegian Krone",
    currency_symbol: "kr",
    currency_iso_code: "NOK",
    country: "Norway",
    country_iso_code: "NO",
  },
  {
    currency_name: "Omani rial",
    currency_symbol: "OMR",
    currency_iso_code: "OMR",
    country: "Oman",
    country_iso_code: "OM",
  },
  {
    currency_name: "Pakistani Rupee",
    currency_symbol: "Rs",
    currency_iso_code: "PKR",
    country: "Pakistan",
    country_iso_code: "PK",
  },
  {
    currency_name: "Panamanian Balboa",
    currency_symbol: "฿",
    currency_iso_code: "PAB",
    country: "Panama",
    country_iso_code: "PA",
  },
  {
    currency_name: "Papua New Guinean Kina",
    currency_symbol: "PGK",
    currency_iso_code: "PGK",
    country: "Papua New Guinea",
    country_iso_code: "PG",
  },
  {
    currency_name: "Paraguayan Guarani",
    currency_symbol: "₲",
    currency_iso_code: "PYG",
    country: "Paraguay",
    country_iso_code: "PY",
  },
  {
    currency_name: "Peruvian Nuevo Sol",
    currency_symbol: "S/.",
    currency_iso_code: "PEN",
    country: "Peru",
    country_iso_code: "PE",
  },
  {
    currency_name: "Philippine Peso",
    currency_symbol: "₱",
    currency_iso_code: "PHP",
    country: "Philippines",
    country_iso_code: "PH",
  },
  {
    currency_name: "Polish Zloty",
    currency_symbol: "zl",
    currency_iso_code: "PLN",
    country: "Poland",
    country_iso_code: "PL",
  },
  {
    currency_name: "Qatari Riyal",
    currency_symbol: "QAR",
    currency_iso_code: "QAR",
    country: "Qatar",
    country_iso_code: "QA",
  },
  {
    currency_name: "Romanian Leu",
    currency_symbol: "lei",
    currency_iso_code: "RON",
    country: "Romania",
    country_iso_code: "RO",
  },
  {
    currency_name: "Russian Ruble",
    currency_symbol: "₽",
    currency_iso_code: "RUB",
    country: "Russia",
    country_iso_code: "RU",
  },
  {
    currency_name: "Rwandan Franc",
    currency_symbol: "R₣",
    currency_iso_code: "RWF",
    country: "Rwanda",
    country_iso_code: "RW",
  },
  {
    currency_name: "Saint Helena Pound",
    currency_symbol: "£",
    currency_iso_code: "SHP",
    country: "Saint Helena, Ascension and Tristan Da Cunha",
    country_iso_code: "SH",
  },
  {
    currency_name: "Samoan Tala",
    currency_symbol: "WS$",
    currency_iso_code: "WST",
    country: "Samoa",
    country_iso_code: "WS",
  },
  {
    currency_name: " Sao Tomean Dobra",
    currency_symbol: "Db",
    currency_iso_code: "STD",
    country: "Sao Tome and Principe",
    country_iso_code: "ST",
  },
  {
    currency_name: "Sao Tome and Principe Dobra",
    currency_symbol: "Db",
    currency_iso_code: "STN",
    country: "Sao Tome and Principe",
    country_iso_code: "ST",
  },
  {
    currency_name: "Saudi Riyal",
    currency_symbol: "SAR",
    currency_iso_code: "SAR",
    country: "Saudi Arabia",
    country_iso_code: "SA",
  },
  {
    currency_name: "Serbian Dinar",
    currency_symbol: "Дин",
    currency_iso_code: "RSD",
    country: "Serbia",
    country_iso_code: "RS",
  },
  {
    currency_name: "Seychellois Rupee",
    currency_symbol: "Rs",
    currency_iso_code: "SCR",
    country: "Seychelles",
    country_iso_code: "SC",
  },
  {
    currency_name: "Sierra Leonean Leone",
    currency_symbol: "Le",
    currency_iso_code: "SLL",
    country: "Sierra Leone",
    country_iso_code: "SL",
  },
  {
    currency_name: "Singapore Dollar",
    currency_symbol: "$",
    currency_iso_code: "SGD",
    country: "Singapore",
    country_iso_code: "SG",
  },
  {
    currency_name: "Solomon Islands Dollar",
    currency_symbol: "$",
    currency_iso_code: "SBD",
    country: "Solomon Islands",
    country_iso_code: "SB",
  },
  {
    currency_name: "Somali Shilling",
    currency_symbol: "S",
    currency_iso_code: "SOS",
    country: "Somalia",
    country_iso_code: "SO",
  },
  {
    currency_name: "South African Rand",
    currency_symbol: "R",
    currency_iso_code: "ZAR",
    country: "South Africa",
    country_iso_code: "ZA",
  },
  {
    currency_name: "South Korean Won",
    currency_symbol: "₩",
    currency_iso_code: "KRW",
    country: "Korea, Republic of South Korea",
    country_iso_code: "KR",
  },
  {
    currency_name: "South Sudanese Pound",
    currency_symbol: "£",
    currency_iso_code: "SSP",
    country: "South Sudan",
    country_iso_code: "SS",
  },
  {
    currency_name: "Sri Lankan Rupee",
    currency_symbol: "Rs",
    currency_iso_code: "LKR",
    country: "Sri Lanka",
    country_iso_code: "LK",
  },
  {
    currency_name: "Sudanese Pound",
    currency_symbol: "SDG",
    currency_iso_code: "SDG",
    country: "Sudan",
    country_iso_code: "SD",
  },
  {
    currency_name: "Surinamese Dollar",
    currency_symbol: "$",
    currency_iso_code: "SRD",
    country: "Suriname",
    country_iso_code: "SR",
  },
  {
    currency_name: "Swazi Lilangeni",
    currency_symbol: "E",
    currency_iso_code: "SZL",
    country: "Swaziland",
    country_iso_code: "SZ",
  },
  {
    currency_name: "Swedish Krona",
    currency_symbol: "kr",
    currency_iso_code: "SEK",
    country: "Sweden",
    country_iso_code: "SE",
  },
  {
    currency_name: "WIR Euro",
    currency_symbol: "CHE",
    currency_iso_code: "CHE",
    country: "Switzerland",
    country_iso_code: "CH",
  },
  {
    currency_name: "Swiss Franc",
    currency_symbol: "₣",
    currency_iso_code: "CHF",
    country: "Switzerland",
    country_iso_code: "CH",
  },
  {
    currency_name: "WIR Franc",
    currency_symbol: "CHW",
    currency_iso_code: "CHW",
    country: "Switzerland",
    country_iso_code: "CH",
  },
  {
    currency_name: "Syrian Pound",
    currency_symbol: "£",
    currency_iso_code: "SYP",
    country: "Syrian Arab Republic",
    country_iso_code: "SY",
  },
  {
    currency_name: "New Taiwan Dollar",
    currency_symbol: "NT$",
    currency_iso_code: "TWD",
    country: "Taiwan",
    country_iso_code: "TW",
  },
  {
    currency_name: "Tajikistani Somoni",
    currency_symbol: "SM",
    currency_iso_code: "TJS",
    country: "Tajikistan",
    country_iso_code: "TJ",
  },
  {
    currency_name: "Tanzanian Shilling",
    currency_symbol: "TZS",
    currency_iso_code: "TZS",
    country: "Tanzania, United Republic of Tanzania",
    country_iso_code: "TZ",
  },
  {
    currency_name: "Thai Baht",
    currency_symbol: "฿",
    currency_iso_code: "THB",
    country: "Thailand",
    country_iso_code: "TH",
  },
  {
    currency_name: "Tongan Paanga",
    currency_symbol: "T$",
    currency_iso_code: "TOP",
    country: "Tonga",
    country_iso_code: "TO",
  },
  {
    currency_name: "Trinidad and Tobago Dollar",
    currency_symbol: "TT$",
    currency_iso_code: "TTD",
    country: "Trinidad and Tobago",
    country_iso_code: "TT",
  },
  {
    currency_name: "Tunisian Dinar",
    currency_symbol: "TND",
    currency_iso_code: "TND",
    country: "Tunisia",
    country_iso_code: "TN",
  },
  {
    currency_name: "Turkish Lira",
    currency_symbol: "₺",
    currency_iso_code: "TRY",
    country: "Turkey",
    country_iso_code: "TR",
  },
  {
    currency_name: "Turkmenistan Manat",
    currency_symbol: "T",
    currency_iso_code: "TMT",
    country: "Turkmenistan",
    country_iso_code: "TM",
  },
  {
    currency_name: "Tuvaluan Dollar",
    currency_symbol: "$",
    currency_iso_code: "TVD",
    country: "Tuvalu",
    country_iso_code: "TV",
  },
  {
    currency_name: "Ugandan Shilling",
    currency_symbol: "USh",
    currency_iso_code: "UGX",
    country: "Uganda",
    country_iso_code: "UG",
  },
  {
    currency_name: "Ukrainian Hryvnia",
    currency_symbol: "₴",
    currency_iso_code: "UAH",
    country: "Ukraine",
    country_iso_code: "UA",
  },
  {
    currency_name: "UAE Dirham",
    currency_symbol: "AED",
    currency_iso_code: "AED",
    country: "United Arab Emirates",
    country_iso_code: "AE",
  },
  {
    currency_name: "Pound Sterling",
    currency_symbol: "£",
    currency_iso_code: "GBP",
    country: "United Kingdom",
    country_iso_code: "GB",
  },
  {
    currency_name: "United States Dollar",
    currency_symbol: "$",
    currency_iso_code: "USD",
    country: "United States",
    country_iso_code: "US",
  },
  {
    currency_name: "Uruguay Peso en Unidades Indexadas",
    currency_symbol: "UYI",
    currency_iso_code: "UYI",
    country: "Uruguay",
    country_iso_code: "UY",
  },
  {
    currency_name: "Uruguayan peso",
    currency_symbol: "$U",
    currency_iso_code: "UYU",
    country: "Uruguay",
    country_iso_code: "UY",
  },
  {
    currency_name: "Uzbekistani Sum",
    currency_symbol: "UZS",
    currency_iso_code: "UZS",
    country: "Uzbekistan",
    country_iso_code: "UZ",
  },
  {
    currency_name: "Vanuatu Vatu",
    currency_symbol: "Vt",
    currency_iso_code: "VUV",
    country: "Vanuatu",
    country_iso_code: "VU",
  },
  {
    currency_name: "Venezuelan Bolivar Digital",
    currency_symbol: "Bs",
    currency_iso_code: "VED",
    country: "Venezuela, Bolivarian Republic of Venezuela",
    country_iso_code: "VE",
  },
  {
    currency_name: "Venezuelan Bolivar Fuerte",
    currency_symbol: "Bs",
    currency_iso_code: "VEF",
    country: "Venezuela, Bolivarian Republic of Venezuela",
    country_iso_code: "VE",
  },
  {
    currency_name: "Venezuelan Bolivar Soberano",
    currency_symbol: "Bs",
    currency_iso_code: "VES",
    country: "Venezuela, Bolivarian Republic of Venezuela",
    country_iso_code: "VE",
  },
  {
    currency_name: "Vietnamese Dong",
    currency_symbol: "₫",
    currency_iso_code: "VND",
    country: "Vietnam",
    country_iso_code: "VN",
  },
  {
    currency_name: "Yemeni Rial",
    currency_symbol: "YER",
    currency_iso_code: "YER",
    country: "Yemen",
    country_iso_code: "YE",
  },
  {
    currency_name: "Zambian Kwacha",
    currency_symbol: "ZK",
    currency_iso_code: "ZMW",
    country: "Zambia",
    country_iso_code: "ZM",
  },
  {
    currency_name: "Zimbabwe Gold",
    currency_symbol: "ZiG",
    currency_iso_code: "ZWG",
    country: "Zimbabwe",
    country_iso_code: "ZW",
  },
  {
    currency_name: "Zimbabwe Dollar",
    currency_symbol: "Z$",
    currency_iso_code: "ZWL",
    country: "Zimbabwe",
    country_iso_code: "ZW",
  },
];
export const Countries = [
  {
    name: "Afghanistan",
    dial_code: "+93",
    code: "AF",
  },
  {
    name: "Aland Islands",
    dial_code: "+358",
    code: "AX",
  },
  {
    name: "Albania",
    dial_code: "+355",
    code: "AL",
  },
  {
    name: "Algeria",
    dial_code: "+213",
    code: "DZ",
  },
  {
    name: "AmericanSamoa",
    dial_code: "+1684",
    code: "AS",
  },
  {
    name: "Andorra",
    dial_code: "+376",
    code: "AD",
  },
  {
    name: "Angola",
    dial_code: "+244",
    code: "AO",
  },
  {
    name: "Anguilla",
    dial_code: "+1264",
    code: "AI",
  },
  {
    name: "Antarctica",
    dial_code: "+672",
    code: "AQ",
  },
  {
    name: "Antigua and Barbuda",
    dial_code: "+1268",
    code: "AG",
  },
  {
    name: "Argentina",
    dial_code: "+54",
    code: "AR",
  },
  {
    name: "Armenia",
    dial_code: "+374",
    code: "AM",
  },
  {
    name: "Aruba",
    dial_code: "+297",
    code: "AW",
  },
  {
    name: "Australia",
    dial_code: "+61",
    code: "AU",
  },
  {
    name: "Austria",
    dial_code: "+43",
    code: "AT",
  },
  {
    name: "Azerbaijan",
    dial_code: "+994",
    code: "AZ",
  },
  {
    name: "Bahamas",
    dial_code: "+1242",
    code: "BS",
  },
  {
    name: "Bahrain",
    dial_code: "+973",
    code: "BH",
  },
  {
    name: "Bangladesh",
    dial_code: "+880",
    code: "BD",
  },
  {
    name: "Barbados",
    dial_code: "+1246",
    code: "BB",
  },
  {
    name: "Belarus",
    dial_code: "+375",
    code: "BY",
  },
  {
    name: "Belgium",
    dial_code: "+32",
    code: "BE",
  },
  {
    name: "Belize",
    dial_code: "+501",
    code: "BZ",
  },
  {
    name: "Benin",
    dial_code: "+229",
    code: "BJ",
  },
  {
    name: "Bermuda",
    dial_code: "+1441",
    code: "BM",
  },
  {
    name: "Bhutan",
    dial_code: "+975",
    code: "BT",
  },
  {
    name: "Bolivia, Plurinational State of",
    dial_code: "+591",
    code: "BO",
  },
  {
    name: "Bosnia and Herzegovina",
    dial_code: "+387",
    code: "BA",
  },
  {
    name: "Botswana",
    dial_code: "+267",
    code: "BW",
  },
  {
    name: "Brazil",
    dial_code: "+55",
    code: "BR",
  },
  {
    name: "British Indian Ocean Territory",
    dial_code: "+246",
    code: "IO",
  },
  {
    name: "Brunei Darussalam",
    dial_code: "+673",
    code: "BN",
  },
  {
    name: "Bulgaria",
    dial_code: "+359",
    code: "BG",
  },
  {
    name: "Burkina Faso",
    dial_code: "+226",
    code: "BF",
  },
  {
    name: "Burundi",
    dial_code: "+257",
    code: "BI",
  },
  {
    name: "Cambodia",
    dial_code: "+855",
    code: "KH",
  },
  {
    name: "Cameroon",
    dial_code: "+237",
    code: "CM",
  },
  {
    name: "Canada",
    dial_code: "+1",
    code: "CA",
  },
  {
    name: "Cape Verde",
    dial_code: "+238",
    code: "CV",
  },
  {
    name: "Cayman Islands",
    dial_code: "+ 345",
    code: "KY",
  },
  {
    name: "Central African Republic",
    dial_code: "+236",
    code: "CF",
  },
  {
    name: "Chad",
    dial_code: "+235",
    code: "TD",
  },
  {
    name: "Chile",
    dial_code: "+56",
    code: "CL",
  },
  {
    name: "China",
    dial_code: "+86",
    code: "CN",
  },
  {
    name: "Christmas Island",
    dial_code: "+61",
    code: "CX",
  },
  {
    name: "Cocos (Keeling) Islands",
    dial_code: "+61",
    code: "CC",
  },
  {
    name: "Colombia",
    dial_code: "+57",
    code: "CO",
  },
  {
    name: "Comoros",
    dial_code: "+269",
    code: "KM",
  },
  {
    name: "Congo",
    dial_code: "+242",
    code: "CG",
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    dial_code: "+243",
    code: "CD",
  },
  {
    name: "Cook Islands",
    dial_code: "+682",
    code: "CK",
  },
  {
    name: "Costa Rica",
    dial_code: "+506",
    code: "CR",
  },
  {
    name: "Cote d'Ivoire",
    dial_code: "+225",
    code: "CI",
  },
  {
    name: "Croatia",
    dial_code: "+385",
    code: "HR",
  },
  {
    name: "Cuba",
    dial_code: "+53",
    code: "CU",
  },
  {
    name: "Cyprus",
    dial_code: "+357",
    code: "CY",
  },
  {
    name: "Czech Republic",
    dial_code: "+420",
    code: "CZ",
  },
  {
    name: "Denmark",
    dial_code: "+45",
    code: "DK",
  },
  {
    name: "Djibouti",
    dial_code: "+253",
    code: "DJ",
  },
  {
    name: "Dominica",
    dial_code: "+1767",
    code: "DM",
  },
  {
    name: "Dominican Republic",
    dial_code: "+1849",
    code: "DO",
  },
  {
    name: "Ecuador",
    dial_code: "+593",
    code: "EC",
  },
  {
    name: "Egypt",
    dial_code: "+20",
    code: "EG",
  },
  {
    name: "El Salvador",
    dial_code: "+503",
    code: "SV",
  },
  {
    name: "Equatorial Guinea",
    dial_code: "+240",
    code: "GQ",
  },
  {
    name: "Eritrea",
    dial_code: "+291",
    code: "ER",
  },
  {
    name: "Estonia",
    dial_code: "+372",
    code: "EE",
  },
  {
    name: "Ethiopia",
    dial_code: "+251",
    code: "ET",
  },
  {
    name: "Falkland Islands (Malvinas)",
    dial_code: "+500",
    code: "FK",
  },
  {
    name: "Faroe Islands",
    dial_code: "+298",
    code: "FO",
  },
  {
    name: "Fiji",
    dial_code: "+679",
    code: "FJ",
  },
  {
    name: "Finland",
    dial_code: "+358",
    code: "FI",
  },
  {
    name: "France",
    dial_code: "+33",
    code: "FR",
  },
  {
    name: "French Guiana",
    dial_code: "+594",
    code: "GF",
  },
  {
    name: "French Polynesia",
    dial_code: "+689",
    code: "PF",
  },
  {
    name: "Gabon",
    dial_code: "+241",
    code: "GA",
  },
  {
    name: "Gambia",
    dial_code: "+220",
    code: "GM",
  },
  {
    name: "Georgia",
    dial_code: "+995",
    code: "GE",
  },
  {
    name: "Germany",
    dial_code: "+49",
    code: "DE",
  },
  {
    name: "Ghana",
    dial_code: "+233",
    code: "GH",
  },
  {
    name: "Gibraltar",
    dial_code: "+350",
    code: "GI",
  },
  {
    name: "Greece",
    dial_code: "+30",
    code: "GR",
  },
  {
    name: "Greenland",
    dial_code: "+299",
    code: "GL",
  },
  {
    name: "Grenada",
    dial_code: "+1473",
    code: "GD",
  },
  {
    name: "Guadeloupe",
    dial_code: "+590",
    code: "GP",
  },
  {
    name: "Guam",
    dial_code: "+1671",
    code: "GU",
  },
  {
    name: "Guatemala",
    dial_code: "+502",
    code: "GT",
  },
  {
    name: "Guernsey",
    dial_code: "+44",
    code: "GG",
  },
  {
    name: "Guinea",
    dial_code: "+224",
    code: "GN",
  },
  {
    name: "Guinea-Bissau",
    dial_code: "+245",
    code: "GW",
  },
  {
    name: "Guyana",
    dial_code: "+595",
    code: "GY",
  },
  {
    name: "Haiti",
    dial_code: "+509",
    code: "HT",
  },
  {
    name: "Holy See (Vatican City State)",
    dial_code: "+379",
    code: "VA",
  },
  {
    name: "Honduras",
    dial_code: "+504",
    code: "HN",
  },
  {
    name: "Hong Kong",
    dial_code: "+852",
    code: "HK",
  },
  {
    name: "Hungary",
    dial_code: "+36",
    code: "HU",
  },
  {
    name: "Iceland",
    dial_code: "+354",
    code: "IS",
  },
  {
    name: "India",
    dial_code: "+91",
    code: "IN",
  },
  {
    name: "Indonesia",
    dial_code: "+62",
    code: "ID",
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    dial_code: "+98",
    code: "IR",
  },
  {
    name: "Iraq",
    dial_code: "+964",
    code: "IQ",
  },
  {
    name: "Ireland",
    dial_code: "+353",
    code: "IE",
  },
  {
    name: "Isle of Man",
    dial_code: "+44",
    code: "IM",
  },
  {
    name: "Israel",
    dial_code: "+972",
    code: "IL",
  },
  {
    name: "Italy",
    dial_code: "+39",
    code: "IT",
  },
  {
    name: "Jamaica",
    dial_code: "+1876",
    code: "JM",
  },
  {
    name: "Japan",
    dial_code: "+81",
    code: "JP",
  },
  {
    name: "Jersey",
    dial_code: "+44",
    code: "JE",
  },
  {
    name: "Jordan",
    dial_code: "+962",
    code: "JO",
  },
  {
    name: "Kazakhstan",
    dial_code: "+77",
    code: "KZ",
  },
  {
    name: "Kenya",
    dial_code: "+254",
    code: "KE",
  },
  {
    name: "Kiribati",
    dial_code: "+686",
    code: "KI",
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    dial_code: "+850",
    code: "KP",
  },
  {
    name: "Korea, Republic of South Korea",
    dial_code: "+82",
    code: "KR",
  },
  {
    name: "Kuwait",
    dial_code: "+965",
    code: "KW",
  },
  {
    name: "Kyrgyzstan",
    dial_code: "+996",
    code: "KG",
  },
  {
    name: "Laos",
    dial_code: "+856",
    code: "LA",
  },
  {
    name: "Latvia",
    dial_code: "+371",
    code: "LV",
  },
  {
    name: "Lebanon",
    dial_code: "+961",
    code: "LB",
  },
  {
    name: "Lesotho",
    dial_code: "+266",
    code: "LS",
  },
  {
    name: "Liberia",
    dial_code: "+231",
    code: "LR",
  },
  {
    name: "Libyan Arab Jamahiriya",
    dial_code: "+218",
    code: "LY",
  },
  {
    name: "Liechtenstein",
    dial_code: "+423",
    code: "LI",
  },
  {
    name: "Lithuania",
    dial_code: "+370",
    code: "LT",
  },
  {
    name: "Luxembourg",
    dial_code: "+352",
    code: "LU",
  },
  {
    name: "Macao",
    dial_code: "+853",
    code: "MO",
  },
  {
    name: "Macedonia",
    dial_code: "+389",
    code: "MK",
  },
  {
    name: "Madagascar",
    dial_code: "+261",
    code: "MG",
  },
  {
    name: "Malawi",
    dial_code: "+265",
    code: "MW",
  },
  {
    name: "Malaysia",
    dial_code: "+60",
    code: "MY",
  },
  {
    name: "Maldives",
    dial_code: "+960",
    code: "MV",
  },
  {
    name: "Mali",
    dial_code: "+223",
    code: "ML",
  },
  {
    name: "Malta",
    dial_code: "+356",
    code: "MT",
  },
  {
    name: "Marshall Islands",
    dial_code: "+692",
    code: "MH",
  },
  {
    name: "Martinique",
    dial_code: "+596",
    code: "MQ",
  },
  {
    name: "Mauritania",
    dial_code: "+222",
    code: "MR",
  },
  {
    name: "Mauritius",
    dial_code: "+230",
    code: "MU",
  },
  {
    name: "Mayotte",
    dial_code: "+262",
    code: "YT",
  },
  {
    name: "Mexico",
    dial_code: "+52",
    code: "MX",
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    dial_code: "+691",
    code: "FM",
  },
  {
    name: "Moldova",
    dial_code: "+373",
    code: "MD",
  },
  {
    name: "Monaco",
    dial_code: "+377",
    code: "MC",
  },
  {
    name: "Mongolia",
    dial_code: "+976",
    code: "MN",
  },
  {
    name: "Montenegro",
    dial_code: "+382",
    code: "ME",
  },
  {
    name: "Montserrat",
    dial_code: "+1664",
    code: "MS",
  },
  {
    name: "Morocco",
    dial_code: "+212",
    code: "MA",
  },
  {
    name: "Mozambique",
    dial_code: "+258",
    code: "MZ",
  },
  {
    name: "Myanmar",
    dial_code: "+95",
    code: "MM",
  },
  {
    name: "Namibia",
    dial_code: "+264",
    code: "NA",
  },
  {
    name: "Nauru",
    dial_code: "+674",
    code: "NR",
  },
  {
    name: "Nepal",
    dial_code: "+977",
    code: "NP",
  },
  {
    name: "Netherlands",
    dial_code: "+31",
    code: "NL",
  },
  {
    name: "Netherlands Antilles",
    dial_code: "+599",
    code: "AN",
  },
  {
    name: "New Caledonia",
    dial_code: "+687",
    code: "NC",
  },
  {
    name: "New Zealand",
    dial_code: "+64",
    code: "NZ",
  },
  {
    name: "Nicaragua",
    dial_code: "+505",
    code: "NI",
  },
  {
    name: "Niger",
    dial_code: "+227",
    code: "NE",
  },
  {
    name: "Nigeria",
    dial_code: "+234",
    code: "NG",
  },
  {
    name: "Niue",
    dial_code: "+683",
    code: "NU",
  },
  {
    name: "Norfolk Island",
    dial_code: "+672",
    code: "NF",
  },
  {
    name: "Northern Mariana Islands",
    dial_code: "+1670",
    code: "MP",
  },
  {
    name: "Norway",
    dial_code: "+47",
    code: "NO",
  },
  {
    name: "Oman",
    dial_code: "+968",
    code: "OM",
  },
  {
    name: "Pakistan",
    dial_code: "+92",
    code: "PK",
  },
  {
    name: "Palau",
    dial_code: "+680",
    code: "PW",
  },
  {
    name: "Palestinian Territory, Occupied",
    dial_code: "+970",
    code: "PS",
  },
  {
    name: "Panama",
    dial_code: "+507",
    code: "PA",
  },
  {
    name: "Papua New Guinea",
    dial_code: "+675",
    code: "PG",
  },
  {
    name: "Paraguay",
    dial_code: "+595",
    code: "PY",
  },
  {
    name: "Peru",
    dial_code: "+51",
    code: "PE",
  },
  {
    name: "Philippines",
    dial_code: "+63",
    code: "PH",
  },
  {
    name: "Pitcairn",
    dial_code: "+872",
    code: "PN",
  },
  {
    name: "Poland",
    dial_code: "+48",
    code: "PL",
  },
  {
    name: "Portugal",
    dial_code: "+351",
    code: "PT",
  },
  {
    name: "Puerto Rico",
    dial_code: "+1939",
    code: "PR",
  },
  {
    name: "Qatar",
    dial_code: "+974",
    code: "QA",
  },
  {
    name: "Romania",
    dial_code: "+40",
    code: "RO",
  },
  {
    name: "Russia",
    dial_code: "+7",
    code: "RU",
  },
  {
    name: "Rwanda",
    dial_code: "+250",
    code: "RW",
  },
  {
    name: "Reunion",
    dial_code: "+262",
    code: "RE",
  },
  {
    name: "Saint Barthelemy",
    dial_code: "+590",
    code: "BL",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    dial_code: "+290",
    code: "SH",
  },
  {
    name: "Saint Kitts and Nevis",
    dial_code: "+1869",
    code: "KN",
  },
  {
    name: "Saint Lucia",
    dial_code: "+1758",
    code: "LC",
  },
  {
    name: "Saint Martin",
    dial_code: "+590",
    code: "MF",
  },
  {
    name: "Saint Pierre and Miquelon",
    dial_code: "+508",
    code: "PM",
  },
  {
    name: "Saint Vincent and the Grenadines",
    dial_code: "+1784",
    code: "VC",
  },
  {
    name: "Samoa",
    dial_code: "+685",
    code: "WS",
  },
  {
    name: "San Marino",
    dial_code: "+378",
    code: "SM",
  },
  {
    name: "Sao Tome and Principe",
    dial_code: "+239",
    code: "ST",
  },
  {
    name: "Saudi Arabia",
    dial_code: "+966",
    code: "SA",
  },
  {
    name: "Senegal",
    dial_code: "+221",
    code: "SN",
  },
  {
    name: "Serbia",
    dial_code: "+381",
    code: "RS",
  },
  {
    name: "Seychelles",
    dial_code: "+248",
    code: "SC",
  },
  {
    name: "Sierra Leone",
    dial_code: "+232",
    code: "SL",
  },
  {
    name: "Singapore",
    dial_code: "+65",
    code: "SG",
  },
  {
    name: "Slovakia",
    dial_code: "+421",
    code: "SK",
  },
  {
    name: "Slovenia",
    dial_code: "+386",
    code: "SI",
  },
  {
    name: "Solomon Islands",
    dial_code: "+677",
    code: "SB",
  },
  {
    name: "Somalia",
    dial_code: "+252",
    code: "SO",
  },
  {
    name: "South Africa",
    dial_code: "+27",
    code: "ZA",
  },
  {
    name: "South Sudan",
    dial_code: "+211",
    code: "SS",
  },
  {
    name: "South Georgia and the South Sandwich Islands",
    dial_code: "+500",
    code: "GS",
  },
  {
    name: "Spain",
    dial_code: "+34",
    code: "ES",
  },
  {
    name: "Sri Lanka",
    dial_code: "+94",
    code: "LK",
  },
  {
    name: "Sudan",
    dial_code: "+249",
    code: "SD",
  },
  {
    name: "Suriname",
    dial_code: "+597",
    code: "SR",
  },
  {
    name: "Svalbard and Jan Mayen",
    dial_code: "+47",
    code: "SJ",
  },
  {
    name: "Swaziland",
    dial_code: "+268",
    code: "SZ",
  },
  {
    name: "Sweden",
    dial_code: "+46",
    code: "SE",
  },
  {
    name: "Switzerland",
    dial_code: "+41",
    code: "CH",
  },
  {
    name: "Syrian Arab Republic",
    dial_code: "+963",
    code: "SY",
  },
  {
    name: "Taiwan",
    dial_code: "+886",
    code: "TW",
  },
  {
    name: "Tajikistan",
    dial_code: "+992",
    code: "TJ",
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    dial_code: "+255",
    code: "TZ",
  },
  {
    name: "Thailand",
    dial_code: "+66",
    code: "TH",
  },
  {
    name: "Timor-Leste",
    dial_code: "+670",
    code: "TL",
  },
  {
    name: "Togo",
    dial_code: "+228",
    code: "TG",
  },
  {
    name: "Tokelau",
    dial_code: "+690",
    code: "TK",
  },
  {
    name: "Tonga",
    dial_code: "+676",
    code: "TO",
  },
  {
    name: "Trinidad and Tobago",
    dial_code: "+1868",
    code: "TT",
  },
  {
    name: "Tunisia",
    dial_code: "+216",
    code: "TN",
  },
  {
    name: "Turkey",
    dial_code: "+90",
    code: "TR",
  },
  {
    name: "Turkmenistan",
    dial_code: "+993",
    code: "TM",
  },
  {
    name: "Turks and Caicos Islands",
    dial_code: "+1649",
    code: "TC",
  },
  {
    name: "Tuvalu",
    dial_code: "+688",
    code: "TV",
  },
  {
    name: "Uganda",
    dial_code: "+256",
    code: "UG",
  },
  {
    name: "Ukraine",
    dial_code: "+380",
    code: "UA",
  },
  {
    name: "United Arab Emirates",
    dial_code: "+971",
    code: "AE",
  },
  {
    name: "United Kingdom",
    dial_code: "+44",
    code: "GB",
  },
  {
    name: "United States",
    dial_code: "+1",
    code: "US",
  },
  {
    name: "Uruguay",
    dial_code: "+598",
    code: "UY",
  },
  {
    name: "Uzbekistan",
    dial_code: "+998",
    code: "UZ",
  },
  {
    name: "Vanuatu",
    dial_code: "+678",
    code: "VU",
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    dial_code: "+58",
    code: "VE",
  },
  {
    name: "Vietnam",
    dial_code: "+84",
    code: "VN",
  },
  {
    name: "Virgin Islands, British",
    dial_code: "+1284",
    code: "VG",
  },
  {
    name: "Virgin Islands, U.S.",
    dial_code: "+1340",
    code: "VI",
  },
  {
    name: "Wallis and Futuna",
    dial_code: "+681",
    code: "WF",
  },
  {
    name: "Yemen",
    dial_code: "+967",
    code: "YE",
  },
  {
    name: "Zambia",
    dial_code: "+260",
    code: "ZM",
  },
  {
    name: "Zimbabwe",
    dial_code: "+263",
    code: "ZW",
  },
];
export const AppConstants = {
  acceptFilesStr: ".doc,.docx,.xls,.xlsx,.pdf,.txt,.csv,.jpg,.png,.jpeg,.bmp",
  acceptFiles: {
    custom: [
      ".doc",
      ".docx",
      ".xls",
      ".xlsx",
      ".pdf",
      ".jpg",
      ".png",
      ".jpeg",
      ".bmp",
      ".txt",
      ".csv",
    ],
  },
};

export enum TransactionTypes {
  Unknown,
  Journal,
  Sales,
  Purchase,
  CrNote,
  DrNote,
  Receipt,
  Payment,
  BadDebts,
  FixedAsset,
  Depreciate,
  DividendAccrual,
  DividendPayment,
  Expenses,
  Contra,
  OpeningBalance,
  Transfer,
  Salary,
  FixedAssetsSellDispose,
  Quotation,
  Dividend,
  QuickEntry,
  Explanation,
}

export enum AccountGroups {
  Unknown = 0,
  Turnover = 1,
  CostOfSales = 2,
  OtherOperatingIncome = 3,
  GainLossOnRevaluationOfAssets = 4,
  InvestmentIncome = 5,
  InterestReceivableEtc = 6,
  SellingAndDistributionCosts = 7,
  AdministrativeExpenses = 8,
  ShareOfOperatingProfit = 9,
  FRS3ExceptionalItems = 10,
  AmountsWrittenOffInvestments = 11,
  InterestPayableSimilarCharges = 12,
  OtherFinanceIncomeCosts = 13,
  Taxation = 14,
  NonControllingInterests = 15,
  ExtraOdrinaryItems = 16,
  TaxationJointVenturesAssociates = 17,
  Dividends = 18,
  PriorYearAdjustment = 19,
  MembersRemunerationCharged = 20,
  CalledupShareCapitalNotPaid = 50,
  FixedAssets = 51,
  FixedAssetsLeased = 52,
  FixedAssetInvestments = 53,
  CurrentAssets = 54,
  DebtorsLessThanOneYear = 55,
  DebtorsMoreThanOneYear = 56,
  CurrentAssetInvestments = 57,
  CashAtBankInHand = 58,
  PrepaymentsAccruedIncome = 59,
  DebtorsOrCreditors = 60,
  CreditorsLessThanOneYear = 61,
  CreditorsMoreThanOneYear = 62,
  FinancialLiabilitiesBorrowings = 63,
  IFRS16Leases = 64,
  ProvisionsForLiabilities = 65,
  AccruedLiabilities = 66,
  EmployeeBenefitObligations = 67,
  CapitalReserves = 68,
  MembersInterest = 69,
  Suspense = 70,
}

export enum AccountNatures {
  Unknown = 0,
  Income = 1,
  Expenses = 2,
  Assets = 3,
  Liability = 4,
}
export enum CompanyGSTTypes {
  Unregistered = 0,
  Regular = 1,
  Composition = 2,
  Consumer = 3,
  Overseas = 4,
  SEZ = 5,
  DeemedExportImport = 6,
}

export enum FeatureStatus {
  placeholder = 0,
  alpha = 1,
  beta = 2,
  release = 3,
}

export enum BusinessTypes {
  PrivateLimited = 1,
  PublicLimited,
  SoleProprietorship,
  Partnership,
  LLP,
  LLC,
  JointVenture,
  HUF,
  NGO,
  GA,
}

export enum AppFeatures {
  Calls = 1,
  LeadSources = 2,
  LinkedinLeads = 3,
  WebForms = 4,
  DayEnd = 5,
  Accounts = 6,
  CorporationTax = 7,
  AML = 8,
  Chats = 9,
  Teams = 10,
  BankStatement = 11,
  Payroll = 12,
  ClientDataRequest = 13,
  Bookkeeping = 14,
  Timesheet = 15,
  Other1 = 16,
  Other2 = 17,
  Other3 = 18,
  Other4 = 19,
  Other5 = 20,
}

export enum InvoicesGetTypes {
  Receipt,
  Payment,
}

export enum PurchaseInvoiceTypes {
  PurchaseInvoice = 1,
  PurchaseDebitNote = 2,
  PurchaseInventory = 3,
  PurchaseRecurring = 4,
}

export enum IPaymentMothod {
  Cash,
  Cheque,
  CreditCard,
  DebitCard,
  DirectDebit,
  StandingOrder,
  WebsitePayment,
  PayPal,
  Amex,
  Other,
  BankTransfer,
}

export enum IndianStates {
  /// <summary>
  /// Prompt will be used for GST State Codes
  /// </summary>
  Unspecified = 0,
  // [Display(Name = "Jammu and Kashmir", ShortName = "JK", Prompt = "01")]
  JammuAndKashmir = 1,
  // [Display(Name = "Himachal Pradesh", ShortName = "HP", Prompt = "02")]
  HimachalPradesh = 2,
  // [Display(Name = "Punjab", ShortName = "PB", Prompt ="03")]
  Punjab = 3,
  // [Display(Name = "Chandigarh", ShortName = "CH", Prompt ="04")]
  Chandigarh = 4,
  // [Display(Name = "Uttarakhand", ShortName = "UK", Prompt ="05")]
  Uttarakhand = 5,
  // [Display(Name = "Haryana", ShortName = "HR", Prompt ="06")]
  Haryana = 6,
  // [Display(Name = "Delhi", ShortName = "DL", Prompt ="07")]
  Delhi = 7,
  // [Display(Name = "Rajasthan", ShortName = "RJ", Prompt ="08")]
  Rajasthan = 8,
  // [Display(Name = "Uttar Pradesh", ShortName = "UP", Prompt ="09")]
  UttarPradesh = 9,
  // [Display(Name = "Bihar", ShortName = "BR", Prompt ="10")]
  Bihar = 10,
  // [Display(Name = "Sikkim", ShortName = "SK", Prompt ="11")]
  Sikkim = 11,
  // [Display(Name = "Arunachal Pradesh", ShortName = "AR", Prompt ="12")]
  ArunachalPradesh = 12,
  // [Display(Name = "Nagaland", ShortName = "NL", Prompt ="13")]
  Nagaland = 13,
  // [Display(Name = "Manipur", ShortName = "MN", Prompt ="14")]
  Manipur = 14,
  // [Display(Name = "Mizoram", ShortName = "MZ", Prompt ="15")]
  Mizoram = 15,
  // [Display(Name = "Tripura", ShortName = "TS", Prompt ="16")]
  Tripura = 16,
  // [Display(Name = "Meghalaya", ShortName = "ML", Prompt ="17")]
  Meghalaya = 17,
  // [Display(Name = "Assam", ShortName = "AS", Prompt ="18")]
  Assam = 18,
  // [Display(Name = "West Bengal", ShortName = "WB", Prompt = "19")]
  WestBengal = 19,
  // [Display(Name = "Jharkhand", ShortName = "JH", Prompt = "20")]
  Jharkhand = 20,
  // [Display(Name = "Orissa", ShortName = "OD", Prompt = "21")]
  Orissa = 21,
  // [Display(Name = "Chhattisgarh", ShortName = "CG", Prompt = "22")]
  Chhattisgarh = 22,
  // [Display(Name = "Madhya Pradesh", ShortName = "MP", Prompt = "23")]
  MadhyaPradesh = 23,
  // [Display(Name = "Gujarat", ShortName = "GJ", Prompt = "24")]
  Gujarat = 24,
  // [Display(Name = "Dadra and Nagar Haveli and Daman and Diu", ShortName = "DN", Prompt = "26")]
  DadraAndNagarHaveliDamanAndDiu = 26,
  // [Display(Name = "Maharashtra", ShortName = "MH", Prompt = "27")]
  Maharashtra = 27,
  // // [Display(Name = "Andhra Pradesh (Old)", ShortName = "APO", Prompt = "28")]
  // AndhraPradeshOld = 28,
  // [Display(Name = "Karnataka", ShortName = "KA", Prompt = "29")]
  Karnataka = 29,
  // [Display(Name = "Goa", ShortName = "GA", Prompt = "30")]
  Goa = 30,
  // [Display(Name = "Lakshadweep", ShortName = "LD", Prompt = "31")]
  Lakshadweep = 31,
  // [Display(Name = "Kerala", ShortName = "KL", Prompt = "32")]
  Kerala = 32,
  // [Display(Name = "Tamil Nadu", ShortName = "TN", Prompt = "33")]
  TamilNadu = 33,
  // [Display(Name = "Puducherry", ShortName = "PY", Prompt = "34")]
  Puducherry = 34,
  // [Display(Name = "Andaman and Nicobar Islands", ShortName = "AN", Prompt = "35")]
  AndamanAndNicobarIslands = 35,
  // [Display(Name = "Telangana", ShortName = "TG", Prompt = "36")]
  Telangana = 36,
  // [Display(Name = "Andhra Pradesh (New)", ShortName = "APN", Prompt = "37")]
  AndhraPradesh = 37,
  // [Display(Name = "Ladakh", ShortName = "LD", Prompt = "38")]
  Ladakh = 38,
  // [Display(Name = "Other Territory", ShortName = "OT", Prompt = "97")]
  OtherTerritory = 97,
  // [Display(Name = "Centre Jurisdiction", ShortName = "CJ", Prompt = "99")]
  CentreJurisdiction = 99,
}
export interface IBaseDrawerModel {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<
    React.SetStateAction<{
      open: boolean;
      id: string;
    }>
  >;
  id?: string;
  setTrigger?: React.Dispatch<React.SetStateAction<boolean>>;
}
